import { render, staticRenderFns } from "./fest-original.vue?vue&type=template&id=cb708818"
import script from "./fest-original.vue?vue&type=script&lang=js"
export * from "./fest-original.vue?vue&type=script&lang=js"
import style0 from "./fest-original.vue?vue&type=style&index=0&id=cb708818&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports